<form  [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
       novalidate #frm="ngForm" (ngSubmit)="salvar(frm)">
  <div class="row">
    <div class="col-md-8">
      <div class="form-group">
        <label>Nome da Área</label>
        <input type="text" class="form-control" name="nome" [(ngModel)]="area.nome" required placeholder="Ex: Cozinha, Bar">
        <label class="invalid-feedback" *ngIf="!area.nome">
          Nome é obrigatório
        </label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Envio Automático</label>
        <div class="mt-2">
          <kendo-switch name="envioAutomatico" [(ngModel)]="area.envioAutomatico"></kendo-switch>
          <span class="ml-2">{{ area.envioAutomatico ? 'Sim' : 'Não' }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="alert alert-info" style="font-size: 0.9em;">
    <i class="fa fa-info-circle mr-1"></i>
    <ng-container *ngIf="!area.envioAutomatico">
       Como o envio não é automático, selecione abaixo quais categorias de produtos devem ser enviadas para esta área.
    </ng-container>
    <ng-container *ngIf="area.envioAutomatico">
      No envio <strong>automático</strong>, o pedido completo sempre será enviado para essa área do Kds.<br>
    </ng-container>
  </div>

  <div class="row" *ngIf="!area.envioAutomatico">
    <div class="col-12">
      <div class="form-group">
        <label>Categorias Vinculadas</label>
        <kendo-multiselect
          [data]="categoriasDisponiveis"
          [(ngModel)]="area.categorias" required
          name="categorias"
          textField="nome"
          valueField="id"
          placeholder="Selecione um ou mais categorias...">
        </kendo-multiselect>

        <label class="invalid-feedback" *ngIf="!area.categorias?.length">
          Selecione uma ou mais categoria
        </label>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label>Status do Pedido ao Entrar nesta Área</label>
        <kendo-dropdownlist [data]="listaStatus" textField="text" valueField="value"
                            [valuePrimitive]="true" [(ngModel)]="area.statusPedido" name="statusPedido">
        </kendo-dropdownlist>
      </div>
    </div>
  </div>

  <div class="form-group">
    <label class="d-block">Possui Etapas de Produção?</label>
    <kendo-switch name="temEtapas" [checked]="temEtapas" (valueChange)="onTemEtapasChange($event)"></kendo-switch>
    <span class="ml-2">{{ temEtapas ? 'Sim' : 'Não' }}</span>

  </div>

  <div class="card bg-light mb-3" *ngIf="temEtapas">
    <div class="card-header">
      <strong>Etapas de Produção</strong>
    </div>
    <div class="card-body">
      <div *ngFor="let etapa of area.etapas; let i = index; let isLast = last" class="etapa-row">
        <span class="badge badge-secondary">{{ i + 1 }}</span>
        <div class="form-group mb-0">

          <input type="text" class="form-control" [(ngModel)]="etapa.nome" [name]="'etapa' + (etapa.$id || etapa.id)"
                 placeholder="Nome da etapa" required>
          <label class="invalid-feedback" *ngIf="!etapa.nome">
            Nome é obrigatório
          </label>
        </div>

        <div class="botoes ">
          <button type="button" class="btn btn-sm btn-outline-secondary btn-icon" (click)="sobeEtapa(i)" [disabled]="i === 0"
                  title="Mover para cima">
            <i class="fa fa-arrow-up"></i>
          </button>
          <button type="button" class="btn btn-sm btn-outline-secondary btn-icon" (click)="desceEtapa(i)" [disabled]="isLast"
                  title="Mover para baixo">
            <i class="fa fa-arrow-down"></i>
          </button>
          <button type="button" class="btn btn-sm btn-outline-danger btn-icon" (click)="removeEtapa(i, etapa)" title="Remover">
            <i class="fa fa-trash"></i>
          </button>
        </div>



      </div>

      <div class="mt-3">
        <button type="button" class="btn btn-primary btn-sm" (click)="addEtapa()">
          <i class="fa fa-plus"></i> Adicionar Etapa
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="mensagemErro" class="alert alert-danger mt-1 mb-2">
        {{mensagemErro}}
  </div>

  <div class="d-flex justify-content-end mt-4">
    <button type="button" class="btn btn-light mr-2" (click)="cancelar()">Cancelar</button>
    <button type="submit" class="btn btn-success" [disabled]="salvando">
      <i class="fa" [ngClass]="salvando ? 'fa-spinner fa-spin' : 'fa-save'"></i> Salvar
    </button>
  </div>

</form>
